'use strict'

/**
 * Map-related utility functions and constants shared across Territory Workbench.
 */

// ── Constants ─────────────────────────────────────────────────

export const MAP_CONTAINER_STYLE = { width: '100%', height: 'calc(100vh - 260px)', minHeight: 520 }
export const HMI_YARD = { lat: 33.43730763333812, lng: -112.11879940396678, label: 'HMI Yard' }
export const DEFAULT_CENTER = { lat: 33.45, lng: -112.07 } // Phoenix, AZ
export const DEFAULT_ZOOM = 10

// ── Distance / formatting helpers ─────────────────────────────

export const toMiles = (distanceKm) => distanceKm * 0.621371

export const haversineMiles = (lat1, lng1, lat2, lng2) => {
  const toRad = (value) => (value * Math.PI) / 180
  const earthRadiusKm = 6371
  const dLat = toRad(lat2 - lat1)
  const dLng = toRad(lng2 - lng1)

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2)

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  return toMiles(earthRadiusKm * c)
}

export const formatMinutes = (minutes) => {
  const num = Number(minutes || 0)
  if (!Number.isFinite(num)) return '0m'
  const rounded = Math.round(num)
  const h = Math.floor(rounded / 60)
  const m = rounded % 60
  if (h <= 0) return `${m}m`
  if (m === 0) return `${h}h`
  return `${h}h ${m}m`
}

export const formatDeltaMinutes = (minutes) => {
  const value = Number(minutes || 0)
  const sign = value >= 0 ? '+' : '-'
  return `${sign}${formatMinutes(Math.abs(value))}`
}
